export default __webpack_public_path__ + "static/N0061-3ec6d4094038b140bc508b3094bc0fd5.png";